var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCatalogueHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 73,
    viewBox: "0 0 69 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 5V58H1V5H36H46Z",
    fill: "#FDE8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12.7941V5H36M23.5 58H1V5H11",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72.5H19.5V48V23.5H32.1579H68.5V34.8421V67C68.5 70.0376 66.0376 72.5 63 72.5Z",
    fill: "#FDE8F2",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46.6842H69V73H19V46.6842Z",
    fill: "#EC187B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4209 34.8421V23H50.5788V34.8421L43.9998 30.8947L37.4209 34.8421Z",
    fill: "#EC187B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2891 66.4211C59.2891 66.6972 59.5129 66.9211 59.7891 66.9211C60.0652 66.9211 60.2891 66.6972 60.2891 66.4211H59.2891ZM60.1426 56.857C59.9474 56.6617 59.6308 56.6617 59.4355 56.857L56.2535 60.039C56.0583 60.2342 56.0583 60.5508 56.2535 60.7461C56.4488 60.9413 56.7654 60.9413 56.9606 60.7461L59.7891 57.9176L62.6175 60.7461C62.8128 60.9413 63.1293 60.9413 63.3246 60.7461C63.5199 60.5508 63.5199 60.2342 63.3246 60.039L60.1426 56.857ZM60.2891 66.4211V57.2105H59.2891V66.4211H60.2891Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 1H15C12.7909 1 11 2.79086 11 5C11 7.20914 12.7909 9 15 9H32C34.2091 9 36 7.20914 36 5C36 2.79086 34.2091 1 32 1Z",
    fill: "#FDE8F2",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCatalogueHover);
export default __webpack_public_path__ + "static/media/addCatalogueHover.d4fcaf69bd2cb6a331d450310a559f75.svg";
export { ForwardRef as ReactComponent };